import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=8e3a6418&scoped=true"
import script from "./CartIcon.vue?vue&type=script&lang=ts"
export * from "./CartIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a6418",
  null
  
)

export default component.exports